const AccountRoles = [
  {
    id: "ADMIN",
    description: "Administrator",
    longDescription:
      "Administrators can edit site information, invite other users to join the site, inactivate users, and request certifier permissions for users."
  },
  {
    id: "EDIT",
    description: "Editor",
    longDescription:
      "Editors can fill out forms and reports. May require certifier permissions to submit, depending on the form."
  },
  {
    id: "VIEW",
    description: "Viewer",
    longDescription: "Viewers can view site information but can't make any changes"
  }
];

export default AccountRoles;
